import { ScreenName } from '@helpcenter/constants';
import FeatureGates from '@atlaskit/feature-gate-js-client';
import { createRelayResource } from '@atlassian/help-center-common-util/resource-router';
import { NUMBER_OF_HELP_CENTERS_INITIAL_FETCH, SORT_ORDER } from '../../constants';
import type { helpCentersManagementPageQuery } from './__generated__/helpCentersManagementPageQuery.graphql';
import HelpCentersManagementPageQuery from './__generated__/helpCentersManagementPageQuery.graphql';

export const HelpCentersManagementResource = createRelayResource<helpCentersManagementPageQuery>({
    type: 'HELP_CENTERS_MANAGEMENT',
    getQuery: ({ route }, { cloudId, workspaceAri }) => {
        const isHelpHubRoute = route.name === ScreenName.HELP_HUBS_MANAGEMENT;
        const filterType = isHelpHubRoute ? 'HELP_HUB' : 'BASIC';

        return {
            parameters: HelpCentersManagementPageQuery,
            variables: {
                cloudId,
                workspaceAri,
                SORT_ORDER,
                NUMBER_OF_HELP_CENTERS_INITIAL_FETCH,
                filterType: FeatureGates.checkGate('enable-jsm-in-hubs') ? filterType : null,
            },
            options: {
                fetchPolicy: 'store-or-network',
            },
        };
    },
});
